import liverpoolCarChargingImage from '../../../assets/images/liverpool/car-charging.jpg';
import liverpoolCityImage from '../../../assets/images/liverpool/liverpool-city.jpg';
import liverpoolStreetImage from '../../../assets/images/liverpool/liverpool-street.jpg';

/** @type {import('./cityLandingPageData').CityData} */
const liverpool = {
    cityName: 'Liverpool',
    searchQuery: 'Liverpool',
    heroHeading: "Find EV Chargers in Liverpool",
    heroSubheading: "Search for electric vehicle charging points across Liverpool and Merseyside. From the Albert Dock to Sefton Park, and beyond, EVBuddy helps you find your nearest charger and charge with confidence.",
    searchPlaceholder: "Try a Liverpool postcode, e.g. L1...",
    networkSection: {
        heading: "Liverpool's Expanding Charging Network",
        paragraphs: [
            "Liverpool is investing heavily in its electric vehicle charging infrastructure, with public charge points now spread across the city and wider Merseyside.",
            <>By 2027 <a href="https://liverpool.gov.uk/evcharging">Liverpool City Council</a> expects to establish 2000 charging points across the city. EVBuddy shows you their locations and latest status, giving you confidence in finding an available charger wherever you are in the city.</>,
        ],
        image: liverpoolCityImage,
        imageAlt: "Electric vehicle charging at a public charge point in Liverpool city centre",
    },
    filterSection: {
        heading: "Find the Right Charger for Your Vehicle",
        paragraphs: [
            "Not all chargers are the same. Whether you need a rapid speed charger for a quick top-up near the City Centre or a slower overnight charger near your Crosby home, EVBuddy allows you to filter by connector type and charging speed so you always find the right match.",
        ],
        image: liverpoolCarChargingImage,
        imageAlt: "EV charging in Liverpool",
    },
    navigateSection: {
        heading: "Navigate Liverpool with Confidence",
        paragraphs: [
            "Driving around Liverpool shouldn't mean worrying about range anxiety. EVBuddy shows you chargers on an interactive map so you can plan your journey across the city, whether you're navigating the City Centre, exploring the Waterfront, or heading out to Cheshire and beyond.",
        ],
        image: liverpoolStreetImage,
        imageAlt: "Liverpool street scene",
    },
    seo: {
        title: "EV Charging Points in Liverpool | Find Chargers Near You | EVBuddy",
        description: "Find electric vehicle charging points across Liverpool. Search for public EV chargers in Liverpool City Centre, Albert Dock, Waterfront, Sefton Park, and across Merseyside with EVBuddy.",
        keywords: "EV charging Liverpool, electric vehicle chargers Liverpool, EV charging points Liverpool, public EV chargers Liverpool, Liverpool electric car charging, charge my EV Liverpool, rapid chargers Liverpool, Merseyside EV chargers",
        canonicalUrl: "https://evbuddy.io/liverpool",
        ogImage: "https://evbuddy.io/static/media/liverpool-city.jpg",
        ogDescription: "Find electric vehicle charging points across Liverpool and Merseyside. Search for public EV chargers with EVBuddy.",
    },
};

export default liverpool;
